export const REQUEST_CATEGORY_LIST = 'REQUEST_CATEGORY_LIST';
export const REMOVE_CATEGORIES = 'REMOVE_CATEGORIES'